import React, { Component } from "react";
import { movies } from "../moviesData";


let BannerImage=movies.results[Math.floor(Math.random()*18)];
console.log(BannerImage);

export class Banner extends Component {
  
  render() {

    return (
      <div className="card banner-card">
        <img
          className="card-img-top"
          src={`https://image.tmdb.org/t/p/original${BannerImage.backdrop_path}`}
          alt=""
        />
        <h5 className="card-title banner-title">
          {BannerImage.title}
        </h5>
        <p className="card-text banner-text">
          {BannerImage.overview}
        </p>
      </div>
    );
  }
}

export default Banner;
